var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('sidebarComponent',{attrs:{"id":"sidebarComponent"}}),_c('div',{attrs:{"id":"main-content"}},[_c('headerComponent',{attrs:{"id":"headerComponent"}}),_c('div',{attrs:{"id":"content"}},[_c('router-view')],1)],1),_c('footerComponent',{attrs:{"id":"footerComponent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }